import * as EaseLibrary from './easeLibrary.js';
// import { isFunction } from "lodash";

// Where el is the DOM element you'd like to test for visibility
export const isHidden = function (el) {
    return (el.offsetParent === null)
}
window.isHidden = isHidden;

export const inArray = function(needle, haystack){
    for (let index = 0; index < haystack.length; index++) {
        const element = haystack[index];
        if(element === needle){
            return true;
        }
    }
    return false;
}
window.inArray = inArray;

export function toggleBodyOverscroll(isHidden) {
    const body = document.getElementsByTagName('body');
    if(body.length){
        const e = body[0];
        if(isHidden === undefined){
            if(inArray('overflow-hidden', e.classList)){
                isHidden = false;
            }else{
                isHidden = true;
            }
        }
        if(isHidden === true){
            e.classList.add('overflow-hidden');
        }else{
            e.classList.remove('overflow-hidden');
        }
    }
}
window.toggleBodyOverscroll = toggleBodyOverscroll;

export function scrollToTargetPosition(top, duration, ease) {
    const startPos = window.pageYOffset;
    let startTime = null;
    let requestId;
    if(duration === null){
        duration = 1000;
    }
    var hasEase = false;
    if(ease){
        hasEase = true;
    }
    var isScrollDown = false;
    if(startPos < top){
        isScrollDown = true;
    }
    const loop = function (currentTime) {
        if (!startTime) {
            startTime = currentTime;
        }
        // Elapsed time in miliseconds
        var time = currentTime - startTime;
        var percent = Math.min(time / duration, 1);
        if(hasEase){
            if(isFunction(EaseLibrary[ease])){
                percent = EaseLibrary[ease](percent);
            }
        }
        if(isScrollDown){
            // this is scrolling down, ie from posY 0 to posY 1000
            var destination = startPos + ((top - startPos)) * percent;
        }else{
            // this is scrolling up, ie from posY 1000 to posY 0
            var destination = startPos - ((startPos - top)) * percent;
        }
        window.scrollTo(0, destination);

        if (time < duration) {
            // Continue moving
            requestId = window.requestAnimationFrame(loop);
        } else {
            window.cancelAnimationFrame(requestId);
        }
    };
    requestId = window.requestAnimationFrame(loop);
};
window.scrollToTargetPosition = scrollToTargetPosition;

export function isVisibleOnScreen(element)
{
    let response = false;
    if(typeof element !== 'undefined'){
        var rect = element.getBoundingClientRect();
        var windowHeight = window.innerHeight || document.documentElement.clientHeight;
        var windowWidth = window.innerWidth || document.documentElement.clientWidth;
        // Check if the element is within the viewport
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= windowHeight &&
            rect.right <= windowWidth &&
            getComputedStyle(element).display !== 'none'
        );
    }
    return response;
}
window.isVisibleOnScreen = isVisibleOnScreen;

export function getHeaderHeight()
{
    let header = document.getElementById('header');
    return header.offsetHeight;
}
window.getHeaderHeight = getHeaderHeight;

export function getProductSummaryHeight()
{
    let firstModuleRow = document.getElementsByClassName('module-row')[0];
    if(firstModuleRow.classList.contains('product-summary-variants') ||
        firstModuleRow.classList.contains('product-summary'))
    {
        return firstModuleRow.offsetHeight;
    }
    if(firstModuleRow.classList.contains('home_hero_banner_2') || 
        firstModuleRow.classList.contains('home_hero_banner_1'))
    {
        return firstModuleRow.offsetHeight;
    }
    return 0;
}
window.getProductSummaryHeight = getProductSummaryHeight;

export function waitForElementByID(selector) {
    return new Promise(resolve => {
        if (document.getElementById(selector)) {
            return resolve(document.getElementById(selector));
        }

        const observer = new MutationObserver(() => {
            if (document.getElementById(selector)) {
                observer.disconnect();
                resolve(document.getElementById(selector));
            }
        });

        // If you get "parameter 1 is not of type 'Node'" error, see https://stackoverflow.com/a/77855838/492336
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}
window.waitForElementByID = waitForElementByID;

export function handleFirstPrductModuleRow() {
    let module_rows = document.getElementsByClassName('module-row');
    if((typeof module_rows !== 'undefined') && module_rows.length){
        module_rows[0].classList.add('mt-xl-0');
        if(module_rows[0].classList.contains('product-summary') || module_rows[0].classList.contains('product-variant-summary')){
            module_rows[0].classList.add('mt-3');
        }
    }
}
window.handleFirstPrductModuleRow = handleFirstPrductModuleRow;

export function setGoogleConsent(consent) {
    const consentMode = {
        'ad_user_data': consent.marketing ? 'granted' : 'denied', // 
        'ad_personalization': consent.marketing ? 'granted' : 'denied',
        'ad_storage': consent.marketing ? 'granted' : 'denied', // google ad, about what ad click and used for analytics
        'analytics_storage': consent.analytics ? 'granted' : 'denied', // vistitor duration, used by analytics and ads
        'functionality_storage': consent.preferences ? 'granted' : 'denied', // language selection
        'personalization_storage': consent.preferences ? 'granted' : 'denied',
        'security_storage': consent.necessary ? 'granted' : 'denied',
        'wait_for_update': consent.wait_time ?? 500
    };
    gtag('consent', 'update', consentMode);
    localStorage.setItem('consentMode', JSON.stringify(consentMode));
}
window.setGoogleConsent = setGoogleConsent;